// extracted by mini-css-extract-plugin
export default {"reviews":"Reviews_reviews__kgVi8","container":"Reviews_container__4iHxy","review":"Reviews_review__eOARF"};